export const forms = {
  fieldRequired: 'Required field.',
  invalidPromoCode: 'This code is invalid',
  invalidEmail: 'This email format is invalid',
  dateInTheFuture: 'Please enter a future date',
  invalidNoOfWords: 'Please enter value greater than',
  minLength: 'Please enter value greater than',
  invalidSelect: 'Required field.',
  toManyElements: 'Max number of languages is ',
  invalidPhone: 'This phone number format is invalid',
  invalidForm: '*Please fill in all the highlighted fields',
  uploadFilesOrNoOfWordsRequired: 'Please enter number of words or upload document',
  noOfWordsTooBig: 'Max value for this field is 2000000000',
  invalidCreditCardNumber: 'Credit card number is invalid.',
  invalidCreditCardHolderName: 'Card holder name is invalid.',
  invalidExpirationMonth: 'Credit card expiration month should be 2 digits.',
  invalidMonth: 'Please only enter values between 1 and 12',
  invalidNumber: 'Please only enter numbers',
  integerValueRequired: 'Please only enter whole numbers',
  invalidExpirationYear: `Credit card expiration year should be 4 digits and greater or equal ${new Date().getFullYear()}`,
  destinationLanguagesIncludeSourceLanguage: 'Target language needs to be different than source language',
};
